import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LocationRequiredPage } from './location-required.page';

const routes: Routes = [
  {
    path: '',
    component: LocationRequiredPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocationRequiredPageRoutingModule {}
